import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';
import { AdditionalDevicePayment, AdditionalDevicePaymentResult } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class AdditionalDevicePaymentApi {
    public static saveAdditionalDevicePayment(_xmStore: XmStore, _http: HttpClient, payload: object): Observable<AdditionalDevicePayment> {
        return of(AdditionalDevicePayment.create<AdditionalDevicePayment>(payload));
    }

    public static getAdditionalDevicePayment(_xmStore: XmStore, _http: HttpClient, paymentDetails: AdditionalDevicePayment): Observable<AdditionalDevicePayment> {
        return of(paymentDetails);
    }

    public static postAdditionalDevicePayment(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<AdditionalDevicePaymentResult> {
        return http.post(`/dpps/${params.dppId}/payment`, params.payload.newOrExistingCardPayload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: AdditionalDevicePaymentResult) => AdditionalDevicePaymentResult.create<AdditionalDevicePaymentResult>(response))
        );
    }
}

ModelBase.persistMapping[StoreAction.SAVE_ADDITIONAL_DEVICE_PAYMENT_DATA] = AdditionalDevicePaymentApi.saveAdditionalDevicePayment;
ModelBase.fetchMapping[StoreAction.GET_ADDITIONAL_DEVICE_PAYMENT] = AdditionalDevicePaymentApi.getAdditionalDevicePayment;
ModelBase.persistMapping[StoreAction.POST_ADDITIONAL_DEVICE_PAYMENT] = AdditionalDevicePaymentApi.postAdditionalDevicePayment;
